import { SelectionModel } from '@angular/cdk/collections';
import { AfterViewInit, Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import _ from 'lodash';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { fadeInUp400ms } from 'src/@smartmanufacturing/animations/fade-in-up.animation';
import { scaleFadeIn400ms } from 'src/@smartmanufacturing/animations/scale-fade-in.animation';
import { stagger20ms } from 'src/@smartmanufacturing/animations/stagger.animation';
import { TableColumn } from 'src/@smartmanufacturing/interfaces/table-column.interface';
import { PermissionSingle } from 'src/app/user-management/shared/models/permission';

@Component({
  selector: 'app-manage-role-permission-expandable',
  templateUrl: './manage-role-permission-expandable.component.html',
  styleUrls: ['./manage-role-permission-expandable.component.scss'],
  animations: [
    stagger20ms,
    fadeInUp400ms,
    scaleFadeIn400ms
  ]
})
export class ManageRolePermissionExpandableComponent<T> implements OnInit, OnChanges, AfterViewInit, OnDestroy {  
  @Input() data: T[];
  @Input() columns: TableColumn<T>[];
  @Input() pageSize = 20;
  @Input() pageSizeOptions = [10, 20, 50];
  @Input() sectionId: number = 0;
  @Input() sectionSelected: boolean = false;

  searchCtrl = new FormControl();

  @Output() onSelectAllEvent = new EventEmitter<any>();
  @Output() onSelectRow = new EventEmitter<any>();
  @Output() onPropSelection = new EventEmitter<any>();

  dataSource = new MatTableDataSource<T>();
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  private destroy$: Subject<void> = new Subject<void>();

  constructor(
  ) { }

  ngOnInit() {
    this.searchCtrl.valueChanges.pipe(
      takeUntil(this.destroy$)
    ).subscribe((value: any) => this.onFilterChange(value));

  }

  get visibleColumns() {
    return this.columns.filter(column => column.visible).map(column => column.property);
  }
  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data']) {
      this.dataSource.data = this.data;
    }
  }

  onSelectAll(event: any): void {
    const filterData = {
      id: this.sectionId,
      isChecked: event?.checked
    };
    this.onSelectAllEvent.emit(filterData);
  }

  rowSelection(event: any, menuId: number): void {
    const rowData = {
      sectionId: this.sectionId,
      isChecked: event?.checked,
      rowId: menuId
    };
    this.onSelectRow.emit(rowData);
  }

  siglePropSelection(event: any, menuId: number, property: string) {
    this.onPropSelection.emit({isChecked: event.checked,
                               rowId: menuId, property,
                               sectionId: this.sectionId
                              })
  }

  onFilterChange(value: string) {
    if (!this.dataSource) {
      return;
    }
    value = value.trim();
    value = value.toLowerCase();
    this.dataSource.filter = value;
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
